import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const FormWrapper = styled.div(
  ({ theme }) => `
  display: grid;
  grid-gap: ${theme.spacing.defaultSmall};
  grid-template-areas:
    "make"
    "model"
    "price"
    "km"
    "button";
  align-items: center;

  ${MEDIA_QUERIES(theme).medium}{
    grid-template-areas:
    "make model"
    "price km"
    "button button";
  }
  ${MEDIA_QUERIES(theme).large}{
    grid-template-areas:
    "make model price km"
    "button button button button";
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  ${MEDIA_QUERIES(theme).xLarge}{
    grid-template-areas:
    "make model price km button"
  }
`
)

export const GridItemWrapper = styled.div<{ gridAreaName: string }>(
  ({ gridAreaName }) => `
  grid-area: ${gridAreaName};
`
)
